var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "VueModal",
    {
      attrs: {
        "modal-class": "modal modal-lg-sm event-guide",
        title: `Event Creation Guide ${_vm.currentPage} of ${_vm.totalPages}`,
      },
      model: {
        value: _vm.modalOpen,
        callback: function ($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen",
      },
    },
    [
      _vm.eventGuide && _vm.page
        ? _c("div", [
            _c("div", { staticClass: "mb-12" }, [
              _c("h1", [
                _vm._v("\n        " + _vm._s(_vm.page.title) + "\n      "),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "intro-copy",
                domProps: { innerHTML: _vm._s(_vm.page.intro) },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "prose",
                domProps: { innerHTML: _vm._s(_vm.page.content) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-center" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: { type: "button" },
                  on: { click: _vm.nextPage },
                },
                [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]
              ),
            ]),
          ])
        : _c("div", [
            _c("div", { staticClass: "mb-12" }, [
              _c(
                "h2",
                { staticClass: "text-n-gray-dark text-2xl font-hairline" },
                [
                  _vm._v(
                    "\n        The event guide is currently under construction, please come back soon!\n      "
                  ),
                ]
              ),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }